import { FC, ReactNode, useState } from 'react';

import { EuiBreadcrumb } from '@elastic/eui';

import { TopMenuContext } from './Context';

export const TopMenuProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<EuiBreadcrumb[]>([]);
  const [extraSection, setExtraSection] = useState<ReactNode | null>(null);

  return (
    <TopMenuContext.Provider
      value={{ breadcrumbs, setBreadcrumbs, extraSection, setExtraSection }}
    >
      {children}
    </TopMenuContext.Provider>
  );
};
